import React from "react";

import AdminDashboard from "../../../../pages/Admin/Dashboard/AdminDashboard";
import Users from "../../../../pages/Admin/Users/Users";
import SettingsFormPage from "../../../../pages/Admin/Settings/SettingsFormPage";
import NewsAdmin from "../../../../pages/Admin/News/NewsAdmin";
import AssociationsAdmin from "../../../../pages/Admin/Associations/AssociationsAdmin";
import EventsAdmin from "../../../../pages/Admin/Events/EventsAdmin";
import ProjetsAdmin from "../../../../pages/Admin/Projets/ProjetsAdmin";
import PublicationsAdmin from "../../../../pages/Admin/Publications/PublicationsAdmin";
import MenusAdmin from "../../../../pages/Admin/MenusAdmin/MenusAdmin";
import PagesAdmin from "../../../../pages/Admin/PagesAdmin/PagesAdmin";
import ServicesMunicipauxAdmin from "../../../../pages/Admin/ServicesMunicipaux/ServicesMunicipauxAdmin";
import TrombinosAdmin from "../../../../pages/Admin/Trombinos/TrombinosAdmin";
import PhotosAdmin from "../../../../pages/Admin/Photos/PhotosAdmin";
import CommercesAdmin from "../../../../pages/Admin/Commerces/CommercesAdmin";
import AbonnementPage from "../../../../pages/Admin/Abonnement/AbonnementPage";
import MediaAlbumsAdmin from "../../../../pages/Admin/MediaAlbums/MediaAlbumsAdmin";

export const adminRoutes = [
  {
    path: "dashboard",
    moduleKey: "dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "news",
    moduleKey: "news",
    element: <NewsAdmin />,
  },
  {
    path: "associations",
    moduleKey: "associations",
    element: <AssociationsAdmin />,
  },
  {
    path: "commerces",
    moduleKey: "commerces",
    element: <CommercesAdmin />,
  },
  {
    path: "services-municipaux",
    moduleKey: "services-municipaux",
    element: <ServicesMunicipauxAdmin />,
  },
  {
    path: "trombinos",
    moduleKey: "trombinos",
    element: <TrombinosAdmin />,
  },
  {
    path: "events",
    moduleKey: "events",
    element: <EventsAdmin />,
  },
  {
    path: "projets",
    moduleKey: "projets",
    element: <ProjetsAdmin />,
  },
  {
    path: "publications",
    moduleKey: "publications",
    element: <PublicationsAdmin />,
  },
  {
    path: "menus",
    moduleKey: "menus",
    element: <MenusAdmin />,
  },
  {
    path: "pages",
    moduleKey: "pages",
    element: <PagesAdmin />,
  },
  {
    path: "photos",
    moduleKey: "photos",
    element: <PhotosAdmin />,
  },
  {
    path: "albums-photos",
    moduleKey: "albums-photos",
    element: <MediaAlbumsAdmin />,
  },
  {
    path: "utilisateurs",
    moduleKey: "utilisateurs",
    element: <Users />,
  },
  {
    path: "parametres",
    moduleKey: "parametres",
    element: <SettingsFormPage />,
  },
  {
    path: "abonnement",
    moduleKey: "abonnement",
    element: <AbonnementPage />,
  },
];
